import styled from 'styled-components';

export const MyTripsMainOuterWrap = styled.div(
    props => `
        width:100%;
        dispaly: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.grey.lightf2};
        position: relative;
    `
)